import { useSelector } from "react-redux";
import {
  IonAvatar,
  IonCard,
  IonGrid,
  IonIcon,
  IonItem,
  IonLabel,
  IonNote,
  IonText,
  isPlatform,
} from "@ionic/react";
import {
  documentTextOutline,
  personOutline,
  calendarOutline,
  bookmarkOutline,
} from "ionicons/icons";
import { DocumentStatusTag } from "../../../components/Document/DocumentStatusTag";
import { selectDocuments } from "../../../store/userShow/selectors/selectDocuments";
export const TodoListSection: React.FC = () => {
  const documents = useSelector(selectDocuments);
  return (
    <>
      <h2 className="ion-no-padding ion-padding-horizontal">
        <IonText color="primary">Documentos</IonText>
      </h2>
      <h4 className="ion-no-padding ion-padding-horizontal">
        <IonText color="primary">Acuerdos</IonText>
      </h4>
      {documents.length === 0 && (
        <IonCard class="ion-margin-bottom">
          <IonItem lines="none">
            <IonLabel>
              <IonText color="medium">No se han encontrado acuerdos</IonText>
            </IonLabel>
          </IonItem>
        </IonCard>
      )}
      {documents.map((document) => (
        <IonCard key={document.id} button>
          <IonItem routerLink={`/app/supervision/acuerdos/${document.id}`} lines="none">
            {isPlatform("desktop") && (
              <IonAvatar slot="start">
                <IonIcon icon={documentTextOutline} size="large" />
              </IonAvatar>
            )}
            <IonLabel>
              <h2 style={{ fontWeight: 500 }} className="ion-text-wrap">
                {document.title}
              </h2>
              <h4>
                <IonIcon icon={personOutline}></IonIcon>
                <IonText class="ion-padding-start">{document.author?.name}</IonText>
              </h4>
              <p>
                <IonIcon icon={calendarOutline}></IonIcon>
                <IonText class="ion-padding-start">{document.createdAt}</IonText>

                <IonIcon icon={bookmarkOutline} class="ion-padding-start" />
                <IonText class="ion-padding-start">{`${document.category?.name}`}</IonText>
              </p>
            </IonLabel>

            <IonNote slot="end">
              <DocumentStatusTag document={document} />
            </IonNote>
          </IonItem>
        </IonCard>
      ))}
    </>
  );
};
